<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('email-templates::page.title.message_templates') }}</h2>

            <b-datatable
                :columns="columns"
                :endpoint="listRoute"
                :hidden-columns="hiddenColumns"
                has-filter-selector
                item-key="id"
            >
                <template #buttons>
                    <div class="px-2">
                        <v-tooltip top transition="v-fab-transition">
                            <template #activator="{ on, attrs }">
                                <v-btn
                                    v-if="can('api.v1.message-templates.store') && can('message-templates.create')"
                                    color="primary"
                                    icon
                                    v-bind="attrs"
                                    :href="getCreateUrl()"
                                    v-on="on"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ t('email-templates::button.create') }}</span>
                        </v-tooltip>
                    </div>
                </template>
                <template #filters="{ filters }">
                    <v-col cols="4" class="pb-0">
                        <b-filter-input
                            v-model="filters.filters.search"
                            :label="t('email-templates::filters.label.search_by_key_or_title')"
                        >
                        </b-filter-input>
                    </v-col>
                </template>
                <template #[`item.subject`]="{ item }">
                    <v-edit-dialog ref="memoDialog" :return-value.sync="item.subject" :transition="null">
                        {{ item.subject }}
                        <template #input>
                            <div class="close-action">
                                <v-icon color="accent" @click="closeEditDialog">mdi-close</v-icon>
                            </div>
                            <p>
                                {{ item.subject }}
                            </p>
                        </template>
                    </v-edit-dialog>
                </template>
                <template #[`item.is_system`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.is_system ? t('default::label.yes') : t('default::label.no') }}
                        </span>
                    </div>
                </template>
                <template #[`item.is_active`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.is_active ? t('default::status.active') : t('default::status.inactive') }}
                        </span>
                    </div>
                </template>
                <template #[`item.actions`]="{ item }">
                    <div class="table-actions">
                        <v-tooltip v-if="can('api.v1.message-templates.update')" top transition="v-fab-transition">
                            <template #activator="{ on, attrs }">
                                <v-btn color="disabled-color" icon v-bind="attrs" :href="getItemUrl(item)" v-on="on">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ t('default::button.edit') }}</span>
                        </v-tooltip>
                    </div>
                </template>
            </b-datatable>
        </v-col>
    </div>
</template>

<script>
export default {
    name: 'MessageTemplatesIndexComponent',
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hiddenColumns: ['id'],
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('email-templates::grid.label.template_key'),
                    value: 'template_key',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('email-templates::grid.label.subject'),
                    value: 'subject',
                    sortable: true,
                    width: 260,
                },
                // {
                //     text: t('email-templates::grid.label.is_system'),
                //     value: 'is_system',
                //     sortable: true,
                //     width: 100,
                // },
                {
                    text: t('email-templates::grid.label.is_active'),
                    value: 'is_active',
                    sortable: true,
                    width: 100,
                },
                {
                    text: t('default::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: null,
                    width: 140,
                    align: 'end',
                },
            ],
        };
    },
    methods: {
        closeEditDialog() {
            const event = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            this.$el.dispatchEvent(event);
        },
        getCreateUrl() {
            return route('message-templates.create');
        },
        getItemUrl(item) {
            return route('message-templates.get', item.id);
        },
    },
};
</script>

<style scoped></style>
